export default __webpack_public_path__ + "static/wpBannerImg-4e5363bd8dee61394f6285dfd75c133e.png";